(() => {
  const storageKey = 'polygons-motion-paused';
  const controls = [...document.querySelectorAll('[data-polygons-motion-control]')];
  if (!controls.length) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let pausedByUser = false;
  try { pausedByUser = localStorage.getItem(storageKey) === 'true'; } catch {}
  const sync = () => {
    const paused = reducedMotion.matches || pausedByUser;
    document.documentElement.dataset.polygonsMotionPaused = String(paused);
    for (const button of controls) {
      button.hidden = false;
      button.disabled = reducedMotion.matches;
      button.textContent = reducedMotion.matches ? button.dataset.pausedLabel : pausedByUser ? button.dataset.resumeLabel : button.dataset.pauseLabel;
      const status = document.getElementById(button.getAttribute('aria-describedby'));
      if (status) status.hidden = !reducedMotion.matches;
    }
    document.dispatchEvent(new CustomEvent('polygons:motion-change', { detail: { paused } }));
  };
  for (const button of controls) button.addEventListener('click', () => {
    if (reducedMotion.matches) return;
    pausedByUser = !pausedByUser;
    try { localStorage.setItem(storageKey, String(pausedByUser)); } catch {}
    sync();
  });
  reducedMotion.addEventListener('change', sync);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    pausedByUser = event.newValue === 'true';
    sync();
  });
  sync();
  const privacyButtons = [...document.querySelectorAll('[data-polygons-cookie-preferences]')];
  const syncPrivacy = () => {
    const available = typeof window.privacyBanner?.showPreferences === 'function';
    for (const button of privacyButtons) button.hidden = !available;
  };
  for (const button of privacyButtons) button.addEventListener('click', async () => {
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      window.location.assign(button.dataset.privacyUrl);
    }
  });
  window.addEventListener('load', syncPrivacy, { once: true });
  document.addEventListener('visitorConsentCollected', syncPrivacy);
  syncPrivacy();
})();
